import './Header.scss';
import { CustomTooltip } from '@/components/custom-tooltip';
import { labels } from '@/locales/en.label';
import IconButton from '@mui/material/IconButton';
import { setEnableSellOutFlag } from 'features/header/redux/header-slice';
import {
	selectEnableSellOutFlag,
	selectSelloutCount,
} from 'features/header/redux/selectors';
import { useEffect } from 'react';
import { MdFlag, MdOutlinedFlag } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { tabs } from './propertyDetails';

export const SelloutCount = () => {
	const path = useLocation().pathname;
	const isPageMyView = tabs.some((tab) => path.includes(tab));
	const dispatch = useAppDispatch();
	const enableSellOutFlag = useAppSelector(selectEnableSellOutFlag);

	const propertySelloutCount = useAppSelector(selectSelloutCount);
	const FlagIcon = isPageMyView && enableSellOutFlag ? MdFlag : MdOutlinedFlag;

	useEffect(() => {
		if (!isPageMyView) {
			dispatch(setEnableSellOutFlag(false));
		}
	}, [dispatch, isPageMyView]);
	const FlagEle = () => {
		return (
			<CustomTooltip content={<p>{labels.header.tooltip.alerts}</p>}>
				<IconButton
					disableFocusRipple
					disableRipple
					aria-label='warning'
					onClick={() => {
						dispatch(setEnableSellOutFlag(!enableSellOutFlag));
					}}
				>
					<FlagIcon className='header__flag-icon' />
					<span className='header__icon-sellout-cnt'>
						{propertySelloutCount}
					</span>
				</IconButton>
			</CustomTooltip>
		);
	};

	return (
		<>
			{
				//If there is sellout counts
				propertySelloutCount! > 0 && enableSellOutFlag ? (
					<FlagEle />
				) : propertySelloutCount === 0 ? (
					<IconButton disableFocusRipple disableRipple aria-label='warning'>
						<MdFlag className='header__icon header__icon-disable' />
					</IconButton>
				) : isPageMyView ? (
					<FlagEle />
				) : (
					<Link
						to={{
							pathname: '/my-view/metrics',
						}}
						style={{ color: '#484848' }}
					>
						<FlagEle />
					</Link>
				)
			}
		</>
	);
};
